import { Pipe, PipeTransform } from '@angular/core';
import { arrayNotEmpty } from 'src/app/utils/array.utils';

@Pipe({
    name: 'arrayNotEmpty',
    standalone: false
})
export class ArrayNotEmptyPipe implements PipeTransform {

  transform(value: any): any {
    return arrayNotEmpty(value);
  }

}
